import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StartPreonboardingJourneyService {
  // private readonly dialogService = inject(DialogService);
  // private readonly journeysPromoDialogService = inject(JourneysPromoDialogService);
  //
  // public startPreonboardingJourneyFlow(): Observable<any> {
  //   const skipJourneysPromoDialog = this.journeysPromoDialogService.getDontShowAgain();
  //
  //   // Handle optional promo dialog logic
  //   const optionalPromoDialog$: Observable<any> = skipJourneysPromoDialog
  //     ? of(null)
  //     : this.dialogService
  //         .openDialog(JourneysPromoDialogComponent, {}, { width: DialogWidth.Large })
  //         .afterClosed.pipe(
  //           filterDefined,
  //           tap(promoDialogResult => {
  //             this.journeysPromoDialogService.setDontShowAgain(promoDialogResult.dontShowAgain);
  //           }),
  //         );
  //
  //   return optionalPromoDialog$.pipe(
  //     switchMap(
  //       () =>
  //         this.dialogService.openDialog(
  //           StartPreonboardingJourneyDialogComponent,
  //           {},
  //           { width: DialogWidth.Small },
  //         ).afterClosed,
  //     ),
  //   );
  // }
}
